<p-confirmDialog key="addperson" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Heading-->
<div style="text-align: center">
	<h2>
		Assign to Topic:
		<span class="InfoText">{{ TopicCD }}</span>
	</h2>
</div>

<!--Person Selector-->
<div class="TopMarginExtra MaxWidth">
	<p-accordion>
		<p-accordionTab header="Select Staff {{ SelectStaffExpand == true ? '(Click to Collapse)' : '(Click to Expand)' }}" [(selected)]="SelectStaffExpand">
			<div>
				<caass-personselector
					[UpdateSchoolSelector]="false"
					[AudienceID]="2"
					[CanSwitchAudience]="false"
					[ShowAllSchools]="false"
					[MultiSelect]="true"
					[buttonMultiSelectProcessCaption]="'Add to List'"
				></caass-personselector>
			</div>
		</p-accordionTab>
	</p-accordion>
</div>

<!--Table to add-->
<div class="TopMarginExtra MaxWidth">
	<p-accordion>
		<p-accordionTab
			header="Staff to Assign ({{ lstPerson.length }}) {{ StaffToAddExpand == true ? '(Click to Collapse)' : '(Click to Expand)' }}"
			[(selected)]="StaffToAddExpand"
		>
			<div>
				<caass-topic-staff-to-add
					[loading]="IsLoading() == true"
					[lstPerson]="lstPerson"
					(RemoveAll)="onRemoveAll()"
					(RemovePerson)="onRemovePerson($event)"
				>
				</caass-topic-staff-to-add>
			</div>
		</p-accordionTab>
	</p-accordion>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onAdd()">Assign Topic</button>
	<button [disabled]="Processing == true" class="btn btn-warning" style="margin-left: 5px" (click)="onClose()">Close</button>
</div>
